import Modal from './Modal';
import CustomModal from './Custom';
import Confirm from './Confirm';
Modal.Confirm = Confirm;
Modal.CustomModal = CustomModal;
export default Modal;



// WEBPACK FOOTER //
// ./components/modal/index.tsx